"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormsyCheckbox = void 0;

var _formsyReact = require("formsy-react");

var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FormsyCheckbox = props => {
  const [formsyProps, checkboxProps] = (0, _utils.filterFormsyProps)(props);
  const {
    value,
    setValue,
    name
  } = formsyProps;
  const {
    onChange,
    ...restProps
  } = checkboxProps;

  if (!(0, _isBoolean.default)(value)) {
    setValue(false);
  }

  const isChecked = !!value;
  const validationErrors = (0, _utils.getValidationErrorsString)(props);
  const labelId = (0, _kebabCase.default)(name);

  function handleChange(value) {
    setValue(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  }

  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({}, restProps, {
    "aria-labelledby": labelId,
    errored: !(0, _isEmpty.default)(validationErrors),
    onChange: handleChange,
    checked: isChecked
  }));
};

exports.FormsyCheckbox = FormsyCheckbox;

var _default = (0, _formsyReact.withFormsy)(FormsyCheckbox);

exports.default = _default;